<template>
  <div class="card box-shadow-low rounded-0 border-0 py-3 px-2 d-flex align-items-center justify-content-center" style="max-width: 720px; min-height: 550px; margin: 0 auto">
    <div class="bg-success mb-3 rounded-circle d-flex align-items-center justify-content-center" style="width: 120px; height: 120px">
      <div class="fa-check-solid text-white" style="font-size: 36px"></div>
    </div>
    <h3 class="m-0">Quote Request Successfully Received</h3>
    <h5 class="text-grey text-center mt-2" style="max-width: 60%">We will contact you soon.</h5>
  </div>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      successPageCustomCode: '',
    };
  },
  mounted() {
    this.successPageCustomCode = window.sm.successPageCustomCode;
    try {
      if (this.successPageCustomCode) {
        this.applyCustomScripts();
      }
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    applyCustomScripts() {
      const dummyElement = document.createElement('div');
      dummyElement.innerHTML = this.successPageCustomCode;
      while (dummyElement.children.length > 0) {
        if (dummyElement.children[0].tagName === 'SCRIPT') {
          const scriptTag = document.createElement('script');
          scriptTag.text = dummyElement.children[0].text;

          if (dummyElement.children[0].src) {
            scriptTag.src = dummyElement.children[0].src;
          }

          document.body.appendChild(scriptTag);
          dummyElement.children[0].remove();
        } else {
          this.$el.parentElement.appendChild(dummyElement.children[0]);
        }
      }
    },
  },
};
</script>
